import { Nudge } from "@/components/nudges/Nudge";
import { ExternalLink } from "@/components/podkit/typography/ExternalLink";
import { NudgeKeys, useNudges } from "@/hooks/use-nudges";
import { TrackLocations } from "@/hooks/use-segment";
import { useSetPreference } from "@/queries/user-preferences-queries";
import { useCallback, useEffect, useState, type FC } from "react";

export const FromGitpodToOnaNudge: FC = () => {
    const { active: nudge, error, isPending } = useNudges();
    const { mutate: setPreference } = useSetPreference();
    const [open, setOpen] = useState(false);

    // Auto-show nudge if applicable
    useEffect(() => {
        if (isPending || error) {
            return;
        }

        if (nudge?.key === NudgeKeys.FROM_GITPOD_TO_ONA) {
            setOpen(true);
            return;
        }
        setOpen(false);
    }, [isPending, error, nudge?.key]);

    const toggleOpen = useCallback(() => {
        setOpen((previousOpenState) => {
            const isNowOpen = !previousOpenState;
            if (!isNowOpen) {
                setPreference({
                    key: NudgeKeys.FROM_GITPOD_TO_ONA,
                    value: new Date().toISOString(),
                });
            }
            return isNowOpen;
        });
    }, [setPreference]);

    const ariaLabelPrefix = "Announcement - From Gitpod to Ona";

    return (
        <Nudge
            open={open}
            toggleOpen={toggleOpen}
            ariaLabelPrefix={ariaLabelPrefix}
            data-testid="nudge-from-gitpod-to-ona-trigger"
            data-track-location={TrackLocations.FromGitpodToOnaNudge}
        >
            <Nudge.Content>
                <Nudge.Header>
                    <Nudge.Title>From Gitpod to Ona</Nudge.Title>
                    <Nudge.Description>
                        Get $100 in free credits in our Core tier when you upgrade for the first time (ending soon).
                        Free credit grant must be used within 3 months.
                    </Nudge.Description>
                </Nudge.Header>
                <Nudge.Action variant="primary" aria-label={`${ariaLabelPrefix} - Read launch blog post`} asChild>
                    <ExternalLink href="https://ona.com/stories/gitpod-is-now-ona" iconSize="sm">
                        Read launch blog post
                    </ExternalLink>
                </Nudge.Action>
            </Nudge.Content>
        </Nudge>
    );
};
